import { c as _c } from "react-compiler-runtime";
import BreezeModalHost from 'chatspot-widget-iframe/BreezeModalHost';
import AsyncConfirmDeleteCommentModal from 'collaboration-sidebar/components/AsyncConfirmDeleteCommentModal';
import AsyncConfirmEditRepeatingTaskModal from 'collaboration-sidebar/features/repeatingTasks/components/AsyncConfirmEditRepeatingTaskModal';
import useHasNavCopilot from '../features/copilot/hooks/useHasNavCopilot';
import EmbeddedCommentPopover from '../features/deepCommenting/EmbeddedCommentPopover';
import AsyncNotificationSettingsModal from './AsyncNotificationSettingsModal';
import AsyncTaskDeleteModal from './AsyncTaskDeleteModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Modals(t0) {
  "use memo";

  const $ = _c(26);
  const {
    confirmDeleteCommentModalProps,
    taskDeleteModalProps,
    confirmEditRepeatingTaskModalProps,
    notificationSettingsModalProps,
    showDeleteCommentModal,
    showTaskDeleteModal,
    showConfirmEditRepeatingTaskModal,
    showNotificationSettingsModal,
    withoutSidebar,
    isReady,
    IFrameError,
    iframeContainerID
  } = t0;
  const hasNavCopilot = useHasNavCopilot();
  let t1;
  if ($[0] !== IFrameError || $[1] !== confirmDeleteCommentModalProps || $[2] !== isReady || $[3] !== showDeleteCommentModal || $[4] !== withoutSidebar) {
    t1 = showDeleteCommentModal && /*#__PURE__*/_jsx(AsyncConfirmDeleteCommentModal, Object.assign({}, confirmDeleteCommentModalProps, {
      withoutSidebar: withoutSidebar,
      isReady: isReady,
      error: IFrameError
    }));
    $[0] = IFrameError;
    $[1] = confirmDeleteCommentModalProps;
    $[2] = isReady;
    $[3] = showDeleteCommentModal;
    $[4] = withoutSidebar;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== showTaskDeleteModal || $[7] !== taskDeleteModalProps) {
    t2 = showTaskDeleteModal && /*#__PURE__*/_jsx(AsyncTaskDeleteModal, Object.assign({}, taskDeleteModalProps));
    $[6] = showTaskDeleteModal;
    $[7] = taskDeleteModalProps;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== confirmEditRepeatingTaskModalProps || $[10] !== showConfirmEditRepeatingTaskModal) {
    t3 = showConfirmEditRepeatingTaskModal && /*#__PURE__*/_jsx(AsyncConfirmEditRepeatingTaskModal, Object.assign({}, confirmEditRepeatingTaskModalProps));
    $[9] = confirmEditRepeatingTaskModalProps;
    $[10] = showConfirmEditRepeatingTaskModal;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== notificationSettingsModalProps || $[13] !== showNotificationSettingsModal) {
    t4 = showNotificationSettingsModal && /*#__PURE__*/_jsx(AsyncNotificationSettingsModal, Object.assign({}, notificationSettingsModalProps));
    $[12] = notificationSettingsModalProps;
    $[13] = showNotificationSettingsModal;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== hasNavCopilot) {
    t5 = !hasNavCopilot && /*#__PURE__*/_jsx(BreezeModalHost, {});
    $[15] = hasNavCopilot;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== iframeContainerID) {
    t6 = /*#__PURE__*/_jsx(EmbeddedCommentPopover, {
      iframeContainerID: iframeContainerID
    });
    $[17] = iframeContainerID;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6) {
    t7 = /*#__PURE__*/_jsxs(_Fragment, {
      children: [t1, t2, t3, t4, t5, t6]
    });
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}